export const SavePendingChangesButtonTestIds = {
  SAVE_BUTTON: 'save-pending-changes.save-button',
  TOGGLE_BUTTON: 'save-pending-changes.toggle-button',
  SAVE_CHANGES_BUTTON: 'save-pending-changes.save-changes-button',
  SEE_CHANGES_BUTTON: 'save-pending-changes.see-changes-button',
  CANCEL_CHANGES_BUTTON: 'save-pending-changes.cancel-changes-button',
  SAVE_SELECTED_CHANGES_BUTTON: 'save-pending-changes.save-selected-changes-button',
  CANCEL_SELECTED_CHANGES_BUTTON: 'save-pending-changes.cancel-selected-changes-button',
  SAVE_SUMMARY_MODAL: 'save-pending-changes.save-summary-modal',
  SAVE_SUMMARY_ACCEPT_BUTTON: 'save-pending-changes.save-summary-accept-button',
};
